module.exports = __webpack_public_path__ + "static/img/UY@3x.e38c739d.png";